import { render, staticRenderFns } from "./ManageLocation.vue?vue&type=template&id=70be1773&scoped=true"
import script from "./ManageLocation.vue?vue&type=script&lang=js"
export * from "./ManageLocation.vue?vue&type=script&lang=js"
import style0 from "./ManageLocation.vue?vue&type=style&index=0&id=70be1773&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70be1773",
  null
  
)

export default component.exports